import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityMatrixService {
  constructor(private http: HttpClient) { }

  getAvailabilityTrips(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.AVAILABILITIES_TRIPS_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getCoverage(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.AVAILABILITIES_COVERAGE_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  saveCoverage(payload: any): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.AVAILABILITIES_COVERAGE_SAVE_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }
}
